import { FC, useState } from 'react';
import { Chip, Popover } from '@mui/material';
import * as Styled from './styled';

type Props = {
  children: string[];
};

export const HiddenArray: FC<Props> = ({ children }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  if (!Array.isArray(children) || !children.length) {
    return '—';
  }

  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  if (children.length === 1) {
    return <Chip size="small" label={children} />;
  }

  return (
    <Styled.Wrapper>
      <Chip size="small" label={children[0]} />
      <Chip
        color="primary"
        variant="outlined"
        size="small"
        clickable
        onClick={handleOpen}
        label={`+${children.slice(1).length}`}
      />
      <Popover
        id={JSON.stringify(children)}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        onClose={handleClose}
      >
        <Styled.List>
          {children.slice(1).map((item, index) => (
            <Chip key={index} size="small" label={item} />
          ))}
        </Styled.List>
      </Popover>
    </Styled.Wrapper>
  );
};
